import {call, put, takeEvery} from 'redux-saga/effects'
import Api from "../services/Api";

function* fetchRentalVehicles(params) {
  try {
    const rentalVehicles = yield call(function() {
      return Api.get('/dealer/rental-vehicles', params.parameters);
    });
    yield put({type: 'FETCH_RENTAL_VEHICLES.SUCCESS', rentalVehicles})
  } catch (error) {
    yield put({type: 'FETCH_RENTAL_VEHICLES.FAILURE', error})
  }
}

export function* watchFetchRentalVehicles() {
  yield takeEvery('FETCH_RENTAL_VEHICLES.REQUEST', fetchRentalVehicles);
}
